/**
 * Printing a receipt (owner 10/29): the page is put in a hidden frame and the browser's print box opens, where the
 * store's receipt printer is picked (Chrome remembers it next time). While the print box is open the counter screen
 * mustn't lock itself, so `printingNow()` tells it a print is in progress.
 */
let until = 0;
export const printingNow = () => Date.now() < until;

export function printHtml(html: string): void {
  const f = document.createElement('iframe');
  f.setAttribute('aria-hidden', 'true');
  Object.assign(f.style, { position: 'fixed', right: '0', bottom: '0', width: '0', height: '0', border: '0' });
  document.body.appendChild(f);
  const w = f.contentWindow!;
  w.document.open(); w.document.write(html); w.document.close();
  until = Date.now() + 5 * 60_000;   // the print box can stay open a while
  const done = () => { until = Date.now() + 1500; setTimeout(() => f.remove(), 2000); };
  w.addEventListener('afterprint', done);
  setTimeout(() => { w.focus(); w.print(); }, 250);   // let the page lay out first
}
